import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {BaseComponent, LeModalService} from "common-shared";
import {ManufacturingItemModel} from "web-shared";
import {ManufacturingGraphModalComponent} from "../../graph/manufacturing-graph-modal/manufacturing-graph-modal.component";
import {takeUntil} from "rxjs/operators";
import {GraphBuilderModalComponent} from "../../graph/graph-builder-modal/graph-builder-modal.component";

@Component({
  selector: 'ime-manufacturing-item-edit-menu-buttons',
  templateUrl: './manufacturing-item-edit-menu-buttons.component.html',
})
export class ManufacturingItemEditMenuButtonsComponent extends BaseComponent implements OnInit {
  public manufacturingItem: ManufacturingItemModel;

  constructor(protected route: ActivatedRoute, protected modalService: LeModalService) {
    super();
  }

  ngOnInit() {
    this.route.params.pipe(takeUntil(this.componentDestroyed)).subscribe(() => {
      this.manufacturingItem = this.route.snapshot.data.entity as ManufacturingItemModel;
    });
  }

  showGraph() {
    this.modalService.show(ManufacturingGraphModalComponent, {initialState: {id: this.manufacturingItem.Id, title: this.manufacturingItem.DisplayName, graphSource: 'Item'} as ManufacturingGraphModalComponent, class: 'modal-full'});
  }

  showGraphBuilder() {
    this.modalService.show(GraphBuilderModalComponent, {initialState: {id: this.manufacturingItem.Id, title: this.manufacturingItem.DisplayName, graphSource: 'Item'} as GraphBuilderModalComponent, class: 'modal-full'});
  }
}
